"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VendorPayoutAccessLogListResponse = exports.VendorPayoutAccessLogQuery = exports.VendorPayoutAccessLogTransport = exports.PayoutAccessAction = exports.PayoutAccessActions = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.PayoutAccessActions = [
    'VCC_CARD_DETAILS_REVEALED',
    'VCC_CARD_DETAILS_REVEAL_FAILED',
    'VCC_PROVISIONED',
    'VCC_CANCELED',
    'VCC_TOS_ACCEPTED',
    'BANK_ACCOUNT_CONNECTED',
    'BANK_ACCOUNT_MIGRATED',
    'PAYMENT_PROFILE_UPDATED',
    'PAYOUT_PAYMENT_METHOD_CHANGED',
];
exports.PayoutAccessAction = typebox_1.Type.Union(exports.PayoutAccessActions.map((a) => typebox_1.Type.Literal(a)));
exports.VendorPayoutAccessLogTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    vendorID: typebox_1.Type.String({ format: 'uuid' }),
    action: exports.PayoutAccessAction,
    actorUserID: typebox_1.Type.String({ format: 'uuid' }),
    metadata: typebox_1.Type.Optional(typebox_1.Type.Record(typebox_1.Type.String(), typebox_1.Type.Unknown())),
    ipAddress: typebox_1.Type.Optional(typebox_1.Type.String()),
    userAgent: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdAt: typebox_1.Type.String({ format: 'date-time' }),
});
exports.VendorPayoutAccessLogQuery = typebox_1.Type.Object({
    vendorID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    action: typebox_1.Type.Optional(exports.PayoutAccessAction),
    actorUserID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    limit: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 1, maximum: 500, default: 25 })),
    offset: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0, default: 0 })),
});
exports.VendorPayoutAccessLogListResponse = (0, common_1.PaginatedResult)(exports.VendorPayoutAccessLogTransport);
//# sourceMappingURL=vendor-payout-access-log-transport.js.map